import { TemplateEntityType } from './template-entity-type.enum';
import { ReplyTemplate } from '@sb-tools/typescript/models/reply-template.model';
import { CategoryWithReplyTemplate } from '@sb-tools/typescript/models/category-with-reply-template.model';
import { CategoryBase } from '@sb-tools/typescript/models/category-base.model';
import { InboxAttachmentBase } from '@sb-tools/typescript/models/inbox-attachment-base.model';

export class TemplateEntity {
    attachments: InboxAttachmentBase[];
    children: TemplateEntity[] = [];
    id: number;
    name: string;
    parentData: CategoryBase[];
    text?: string;
    type: TemplateEntityType;

    static castFromCategoryWithReplyTemplate(categoryWithReplyTemplate: CategoryWithReplyTemplate): TemplateEntity {
        const templateEntity = new TemplateEntity();
        templateEntity.id = categoryWithReplyTemplate.id;
        templateEntity.name = categoryWithReplyTemplate.name;
        templateEntity.parentData = categoryWithReplyTemplate.parentData;
        templateEntity.type = TemplateEntityType.category;

        categoryWithReplyTemplate.children.forEach((child) => {
            templateEntity.children.push(this.castFromCategoryWithReplyTemplate(child));
        });

        categoryWithReplyTemplate.replyTemplates.forEach((replyTemplate) => {
            templateEntity.children.push(this.castFromReplyTemplate(replyTemplate, templateEntity));
        });

        return templateEntity;
    }

    static castFromReplyTemplate(replyTemplate: ReplyTemplate, parentCategory?: TemplateEntity): TemplateEntity {
        const templateEntity = new TemplateEntity();
        templateEntity.id = replyTemplate.id;
        templateEntity.name = replyTemplate.name;
        templateEntity.text = replyTemplate.text;
        templateEntity.attachments = replyTemplate.attachments;
        templateEntity.type = TemplateEntityType.template;

        if (parentCategory) {
            templateEntity.parentData = parentCategory.parentData.concat([
                {
                    id: parentCategory.id,
                    name: parentCategory.name,
                    label: parentCategory.name,
                },
            ]);
        }

        return templateEntity;
    }
}
